@if(selectedProduct && selectedProduct.length == 0){
<section class="product-section" (click)="openProductList(AttachMemberProduct)">
  <span class="add">Add Products {{ productType | titlecase }}</span>
  <div class="product">
    <div class="add-product">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </div>
  </div>
</section>
}@else{
<div style="width: 100%">
  <div class="card-mail" *ngFor="let list of selectedProduct">
    <div class="card-mail__image">
      <img [src]="imgUrl + list.indexImage" [alt]="'Image ' + list.name" />
    </div>
    <div>
      <div class="card-mail__header">
        <div class="card-mail__title">
          <div>{{ list.name.substr(0, 40) }}<span *ngIf="list.name.length > 40">...</span></div>
        </div>
        <div class="card-mail__logo" *ngIf="list.user_detail?.id">
          <img [src]="imgUrl + list.user_detail?.shop_logo" (error)="commonService.handleError($event)" />
        </div>
      </div>

      <div class="card-mail__footer" style="display: flex; align-items: center; justify-content: space-between; line-height: 1">
        @if(list?.foodSpecs && !isCommunityProduct){
        <div class="price" *ngIf="list?.foodSpecs && list?.foodSpecs[0]?.key != '-'">
          <span>$</span>{{ list?.foodSpecs[0]?.key }} <small>{{ list.unit != "null" && list.unit != 0 ? list.unit : "" }}</small>
        </div>
        }@else{
        <ng-container *ngIf="list?.memberShopProductsVariations">
          <div class="price"  *ngIf="list?.type != 'promote'">
            <span *ngIf="list?.memberShopProductsVariations[0]?.key > 0">$</span>
            {{ list?.memberShopProductsVariations[0]?.key > 0 ? list?.memberShopProductsVariations[0]?.key : "FREE" }}
          </div>
        </ng-container>
        }
        <span class="favorite">
          <span>{{ list?.foodFavoritesCount }}</span>
          <img src="https://demo.kachiing.com/assets/images/heart.svg" />
        </span>
      </div>
      <div class="card-mail__tags" *ngIf="list?.type">
        @if(list?.type == 'rental' || list?.type == 'promote') {
        <span class="tag" style="background-color: #b32596;" *ngIf="list?.type == 'rental'">Rental</span>
        <span class="tag" style="background-color: transparent;" placement="top" ngbTooltip="Shout Out" *ngIf="list?.type == 'promote'">
          <svg viewBox="0 0 127 122" fill="none" style="fill: #592880;">
            <path d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z"></path>
            <path d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z"></path>
            <path d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z"></path>
            <path d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z"></path>
            <path d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z"></path>
          </svg>
        </span>
        } @else {
        <span></span>
        }
        <span class="tag" style="background-color: #592880;" placement="top" ngbTooltip="{{ (list?.subRegionName?.includes('all') ? 'Doorstep' : regionSplit(list?.subRegionName)) | titlecase }}">
          {{ (list?.subRegionName?.includes("all") ? "Doorstep" : regionSplit(list?.subRegionName)) | titlecase }}
        </span>
      </div>
    </div>
  </div>
</div>

<!-- <section style="width: 100%; padding: 0 10px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 20px">
  <div style="font-size: 16px; box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3); background-color: #fff; padding: 8px; border-radius: 8px; height: 100%; position: relative" *ngFor="let list of selectedProduct">
    <div style="position: relative">
      <div style="position: absolute; bottom: 0; left: 0" *ngIf="list.points">
        <span style="color: #fff; background-color: #17a2b8; display: inline-block; padding: 4px 6px; font-size: 75%; font-weight: 700; line-height: 1; text-align: center; white-space: nowrap; vertical-align: baseline; border-radius: 4px; transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"> <i class="fa-solid fa-medal"></i> {{ list.points }} </span>
      </div>
      <img [src]="imgUrl + list.indexImage" [ngStyle]="list.user_detail?.id ? { 'border-radius': '0 0 0 30px' } : {}" style="width: 100%; border-radius: 8px; object-fit: cover; aspect-ratio: 1 / 1" [alt]="'Image ' + list.name" (error)="commonService.handleError($event)" />
      <div *ngIf="list.user_detail?.id && list.user_detail?.shop_logo" style="width: 75px; height: 75px; border-radius: 50%; position: absolute; left: 4px; bottom: -12px; object-fit: cover; display: flex; align-items: center; justify-content: center; background-color: #fff; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px); box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px">
        <img style="width: 75%" [src]="imgUrl + list.user_detail?.shop_logo" (error)="commonService.handleError($event)" />
      </div>
    </div>
    <div>
      <div style="margin: 16px 0 8px; font-size: 18px; line-height: 1.1; height: 39.6px; font-weight: 600; overflow: hidden">{{ list.name.substr(0, 40) }}<span *ngIf="list.name.length > 40">...</span></div>

      <div style="display: flex; align-items: center; justify-content: space-between; line-height: 1">
        @if(list?.foodSpecs && !isCommunityProduct){
        <div style="color: #592880; font-size: 24px; font-weight: 600" *ngIf="list?.foodSpecs && list?.foodSpecs[0]?.key != '-'"><span style="font-size: 16px">$</span>{{ list?.foodSpecs[0]?.key }}</div>
        }@else{
        <ng-container *ngIf="list?.memberShopProductsVariations">
          <div style="color: #592880; font-size: 24px; font-weight: 600" *ngIf="list?.type != 'promote'">
            <span style="font-size: 16px" *ngIf="list?.memberShopProductsVariations[0]?.key > 0">$</span>
            {{ list?.memberShopProductsVariations[0]?.key > 0 ? list?.memberShopProductsVariations[0]?.key : "FREE" }}
          </div>
        </ng-container>
        }
        <span style="display: flex; margin-left: auto; align-items: center">
          <span style="margin-right: 4px">{{ list?.foodFavoritesCount }}</span>
          <i style="font-size: 20px" *ngIf="!list?.foodFavoritesCount" class="fa-regular fa-heart"></i>
          <i style="font-size: 20px; color: salmon" *ngIf="list?.foodFavoritesCount" class="fa-solid fa-heart"> </i>
        </span>
      </div>
      <small style="position: relative; top: -4px; height: 25px; display: block">{{ list.unit != "null" && list.unit != 0 ? list.unit : "" }}</small>
      <div style="color: #fff; font-size: 14px; display: flex; align-items: center; justify-content: space-between" *ngIf="list?.type">
        @if(list?.type == 'rental' || list?.type == 'promote') {
        <span style="background-color: #b32596; padding: 0 4px; border-radius: 4px; max-width: 112px; white-space: nowrap; text-overflow: ellipsis" *ngIf="list?.type == 'rental'">Rental</span>
        <span style="background-color: transparent; padding: 0 4px; border-radius: 4px; max-width: 112px; white-space: nowrap; text-overflow: ellipsis" placement="top" ngbTooltip="Shout Out" *ngIf="list?.type == 'promote'">
          <svg viewBox="0 0 127 122" fill="none" style="fill: #592880; width: 24px">
            <path d="M72.85 104.24L71.17 94.2599C71.05 93.5199 70.34 93.02 69.6 93.15L40.66 98.2299C39.96 98.3499 39.48 99 39.55 99.7L40.62 109.92C40.7 110.7 41.43 111.25 42.2 111.11L71.75 105.78C72.49 105.66 72.98 104.97 72.85 104.24Z"></path>
            <path d="M85.71 16.1499L18.63 77.0499L91.03 25.4099L122.01 75.5599L84.2 3.49994C78.7 1.83994 72.86 0.939941 66.82 0.939941C33.65 0.939941 6.76001 27.8299 6.76001 60.9999C6.76001 66.5599 7.53001 71.93 8.95001 77.03L7.86002 79.5399L0.830017 83.78L8.53001 80.9899L9.75002 79.6899C9.75002 79.6999 9.75001 79.7 9.76001 79.71L79.55 6.56995L85.71 16.1499Z"></path>
            <path d="M96.34 8.7002L126.74 64.9702C126.83 63.6602 126.88 62.3402 126.88 61.0002C126.88 38.5602 114.57 19.0102 96.34 8.7002Z"></path>
            <path d="M80.06 103.9C80.71 108.03 77.94 111.91 73.82 112.63L46.26 117.45C52.67 119.79 59.59 121.06 66.81 121.06C91.88 121.06 113.36 105.69 122.36 83.8599L78.15 91.8499L80.06 103.9Z"></path>
            <path d="M22.21 101.22L20.23 101.54L10.01 109L24.13 103.21C27.23 106.35 30.66 109.16 34.39 111.55L32.58 99.52L22.21 101.22Z"></path>
          </svg>
        </span>
        } @else {
        <span></span>
        }
        <span style="background-color: #592880; padding: 0 4px; border-radius: 4px; max-width: 112px; white-space: nowrap; text-overflow: ellipsis" placement="top" ngbTooltip="{{ (list?.subRegionName?.includes('all') ? 'Doorstep' : regionSplit(list?.subRegionName)) | titlecase }}">
          {{ (list?.subRegionName?.includes("all") ? "Doorstep" : regionSplit(list?.subRegionName)) | titlecase }}
        </span>
      </div>
    </div>
  </div>
  <div style="width: 40%; padding: 10px; box-sizing: border-box" *ngFor="let list of selectedProduct">
    <div style="font-size: 1rem; background-color: #ffffff; padding: 0.5em; border-radius: 0.5em; height: 100%; position: relative; border: 1px solid #e0e0e0">
      <div style="position: relative; cursor: pointer">
        <div style="position: absolute; top: -3px; left: -3px; padding: 0.35rem 0.65rem; background-color: rgba(255, 87, 34, 0.75); color: #fff; font-size: 0.75rem; border-radius: 0.5em; line-height: 1; box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.24)" *ngIf="list.isWithinRadius && list?.type != 'promote'"><i class="fa-solid fa-location"></i> {{ list.distance }}</div>
        <img loading="lazy" src="{{ imgUrl + list.indexImage }}" style="width: 100%; border-radius: 0.5em; object-fit: cover; aspect-ratio: 1 / 1; max-width: 100%" class="img-pro" [alt]="'Image ' + list.name" (error)="commonService.handleError($event)" />
        <div *ngIf="list.user_detail?.id && list.user_detail?.shop_logo" style="width: 10em; height: 10em; margin-top: -7em; position: relative; z-index: 9; display: flex; align-items: center; justify-content: center; background-color: #fff; border-radius: 0.25em; box-shadow: 0px 2px 8px rgba(99, 99, 99, 0.2)">
          <img loading="lazy" src="{{ imgUrl + list.user_detail?.shop_logo }}" (error)="commonService.handleError($event)" style="width: 90%" />
        </div>
      </div>
      <div class="detail" style="line-height: 1.5715">
        <div class="detail_title" style="margin: 1em 0 0.5em; font-size: 1.1rem; line-height: 1.1; height: 2.5rem; font-weight: 600; overflow: hidden">{{ list.name.substr(0, 40) }}<span *ngIf="list.name.length > 40">...</span></div>

        <div class="bar" style="display: block; line-height: 1">
          <div class="price" style="color: #007bff; font-size: 1.5em; font-weight: 600" *ngIf="list?.foodSpecs && list?.foodSpecs[0]?.key != '-'"><span>$</span>{{ list?.foodSpecs[0]?.key }}</div>
          <div *ngIf="!list?.foodSpecs">
            <ng-container *ngIf="list?.memberShopProductsVariations">
              <div class="price" style="color: #007bff; font-size: 1.5em; font-weight: 600" *ngIf="list?.type != 'promote'">
                <span *ngIf="list?.memberShopProductsVariations[0]?.key > 0">$</span>
                {{ list?.memberShopProductsVariations[0]?.key > 0 ? list?.memberShopProductsVariations[0]?.key : "FREE" }}
              </div>
            </ng-container>
          </div>

          <span class="favorite" style="display: inline-block; margin-left: auto; align-items: center">
            <span class="number" style="margin-right: 0.25em">{{ list?.foodFavoritesCount }}</span>
            <i *ngIf="list?.foodFavoritesCount" style="color: salmon" class="fa-solid fa-heart"> </i>
            <i *ngIf="!list?.foodFavoritesCount" class="fa-solid fa-heart"> </i>
          </span>
        </div>
        <small style="height: 10px; display: block">{{ list.unit != "null" && list.unit != 0 ? list.unit : "" }}</small>
        <div class="tag" style="background-color: #007bff; padding: 0 0.25em; border-radius: 0.25em; color: #fff; font-size: 0.9em; display: inline-block; width: auto; align-items: center" *ngIf="list?.type">
          <span *ngIf="list?.type == 'rental'" class="rental">Rental</span>
          <span *ngIf="list?.type == 'promote'" class="promoted">Shout Out</span>
          <span>{{ (list?.subCategoryName?.includes("All") ? "Doorstep" : regionSplit(list?.subRegionName)) | titlecase }}</span>
        </div>
      </div>
    </div>
  </div>
</section> -->

}

<ng-template #AttachMemberProduct let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="attach__card--option">
    <button class="my-button-3 secondary" (click)="attachProduct(productList); modal.dismiss('Cross click')"><i class="fa-solid fa-save"></i>Attach</button>
  </div>
  <div class="my-modal__body mt-5">
    <!-- <h2 class="title">Attach Product</h2> -->
    <!-- <div style="color: var(--primary)">Product</div> -->
    <section class="attach">
      <div class="attach__card" *ngFor="let list of productList">
        <div (click)="AddProduct.click()">
          <common-product-card-view [list]="list" [isCommunityProduct]="productType == 'community'"></common-product-card-view>
          <div class="attach__card--option">
            <input type="checkbox" style="width: 2rem; height: 2rem" (click)="$event.stopPropagation()" #AddProduct [(ngModel)]="list.checked" />
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-template>
